import { Card, Tabs } from '@classgo/ui';
import { useState } from 'react';

import { useT } from '../../i18n';
import { can } from '../../shell';
import { useTenant } from '../../tenant/tenant-provider';
import { ExcusesTab } from './excuses';
import { RollTab } from './roll';
import { SettingsTab } from './settings';

type View = 'roll' | 'excuses' | 'settings';

/**
 * Attendance (#114 over the API of #105): the roll of a group on a day or in a session, marked
 * from a phone or a desk with `attendance:write` (read-only without it); the excuses the
 * families sent, pending first, to accept or reject; and the school's absence threshold with the
 * alerts it raised. `Tabs` mounts only the open panel, so the roll's readers cost no extra
 * requests.
 */
export const AttendanceScreen = () => {
  const t = useT();
  const { session } = useTenant();
  const canWrite = can(session, 'attendance:write');
  const [view, setView] = useState<View>('roll');
  return (
    <Card title={t('attendance.title')}>
      <Tabs
        label={t('attendance.title')}
        value={view}
        onChange={(id) => setView(id === 'excuses' || id === 'settings' ? id : 'roll')}
        items={[
          {
            id: 'roll',
            label: canWrite ? t('attendance.tab.mark') : t('attendance.tab.roll'),
            content: <RollTab canWrite={canWrite} />,
          },
          {
            id: 'excuses',
            label: t('attendance.tab.excuses'),
            content: <ExcusesTab canWrite={canWrite} />,
          },
          {
            id: 'settings',
            label: t('attendance.tab.settings'),
            content: <SettingsTab canWrite={canWrite} />,
          },
        ]}
      />
    </Card>
  );
};
